import { AsyncWidgetConfigurationNav } from '@jira/navigation-apps__horizontal-nav-csm-widget-configuration/src/AsyncWidgetConfigurationNav.tsx';
import { customerExperiencesNavigationResource } from '@jira/router-resources__customer-experiences-navigation/src/customerExperiencesNavigationResource.tsx';
import { MenuIdCustomerExperiences } from '@jira/navigation-apps__constants/src/MenuIdCustomerExperiences.tsx';
import ErrorPagesNotFound from '@jira/router-routes__common/src/ui/error-pages/not-found/index.tsx';
import { getServiceDeskSettingsResources } from '@jira/router-resources__service-desk-common/src/getServiceDeskSettingsResources.tsx';
import { serviceProjectLayout } from '@jira/platform__layouts-service-project-layout/src/index.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { helpCenterSettingsWidgetConfigurationCustomizeRoute } from '@jira/router-routes__help-center-settings-routes/src/helpCenterSettingsWidgetConfigurationCustomizeRoute.tsx';
import type { Route } from '@atlassian/react-resource-router';
import { HelpCenterSettingsWidgetConfigurationCustomizeEntryPoint } from './ui/widget-configuration-customize/HelpCenterSettingsWidgetConfigurationCustomizeEntryPoint.tsx';

export const helpCenterSettingsWidgetConfigurationCustomizeRouteEntry: Route = createEntry(
	helpCenterSettingsWidgetConfigurationCustomizeRoute,
	() => ({
		group: 'helpcenter-settings',
		perfMetricKey: 'customer-service.widget-configuration.customize',
		layout: serviceProjectLayout,
		navigation: {
			menuId: MenuIdCustomerExperiences,
			horizontal: AsyncWidgetConfigurationNav,
		},
		// eslint-disable-next-line no-restricted-syntax
		component: ErrorPagesNotFound,
		entryPoint: () => {
			return HelpCenterSettingsWidgetConfigurationCustomizeEntryPoint;
		},
		resources: [...getServiceDeskSettingsResources(), customerExperiencesNavigationResource],
		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
